import { createContext, useState, useContext, ReactNode } from 'react';
import LoadingComponent from "../components/commons/LoadingComponent";

export interface BusinessSummary {
    id?: number;
    name?: string;
    active?: string;
    image?: string;
    /** Primary brand hex color (buttons, accents, gradient start). */
    brandColor?: string | null;
    /** Darker variant — hover states, gradient end. */
    brandColorStrong?: string | null;
    /** Lighter variant — soft backgrounds, selected/hover tints. */
    brandColorSoft?: string | null;
    /** Comma-separated PaymentMethod codes. */
    acceptedPaymentMethods?: string | null;
    /** ISO 4217 code (USD, BRL, EUR...) — drives money symbol + Stripe currency. */
    currency?: string | null;
    /** IANA timezone (America/Sao_Paulo, ...) for calendar / display. */
    timezone?: string | null;
    /** UI language ("English" / "Portuguese (Brazil)") — drives the admin i18n. */
    language?: string | null;
    /** Admin time display: 'H24' (24-hour, default) or 'AMPM' (12-hour). */
    timeFormat?: string | null;
    /** Public URL slug — used to build the consumer booking link. */
    slug?: string | null;
    /** Business country ("brazil", "canada"...) — gates country-specific payment methods. */
    country?: string | null;
    /** PIX key — shown at charge time so the client can transfer. */
    pixKey?: string | null;
    /** Bank details for bank-transfer payments — shown at charge time. */
    bankTransferInfo?: string | null;
}

export interface BusinessContextType {
    allBusiness: BusinessSummary[] | null;
    setAllBusiness: (listOfBusinessSummary: BusinessSummary[] | null) => void;
    selectedBusiness: BusinessSummary | null;
    setSelectedBusiness: (business: BusinessSummary | null) => void;
    isBusinessLoading: boolean;
    setIsBusinessLoading: (isLoading: boolean) => void;
}

export const BusinessContext = createContext<BusinessContextType | undefined>(undefined);

export const BusinessProvider = ({ children }: { children: ReactNode }) => {

    const [allBusiness, setAllBusiness] = useState<BusinessSummary[] | null>(null);
    const [selectedBusiness, setSelectedBusiness] = useState<BusinessSummary | null>(null);
    const [isBusinessLoading, setIsBusinessLoading] = useState<boolean>(false);
    return (
        <BusinessContext.Provider value={{ allBusiness, setAllBusiness, selectedBusiness, setSelectedBusiness,isBusinessLoading, setIsBusinessLoading }}>
            {children}
        </BusinessContext.Provider>
    );
};

export const useBusinessContext = () => {
    const context = useContext(BusinessContext);
    if (context === undefined) {
        throw new Error('useBusinessContext must be used within a BusinessProvider');
    }
    return context;
};
